import { randomIntFromInterval } from '~/bootcamp/Activities/utils/activities.utils'

import { getRangesByDifficulty } from './constants'

/**
 * Responsible to generate final term after adjustment and shuffle
 * @param difficultyLevel
 * @param taskHistory
 * @returns [ Numerator, Denominator ]
 */
export function generateTerms(difficultyLevel: number, taskHistory: number[]): number[] {
  const { minNumerator, maxNumerator, minDenominator, maxDenominator } = getRangesByDifficulty(difficultyLevel)

  const denominator = randomIntFromInterval(minDenominator, maxDenominator, taskHistory)

  const numerator = randomIntFromInterval(minNumerator, Math.min(maxNumerator, denominator))

  if ((taskHistory.length > 0 && taskHistory[0] === denominator) || numerator === denominator) {
    return generateTerms(difficultyLevel, taskHistory)
  }

  return [numerator, denominator]
}
